import { useEffect, useState } from "react";

const useIsMobile = () => {
  const [matches, setMatches] = useState(
    window.matchMedia("(max-width: 768px)").matches ||
      "ontouchstart" in window ||
      /(android|iphone|ipad|ipod|blackberry|bb10|mini|windows\sce|palm)/i.test(
        navigator.userAgent
      )
  );

  useEffect(() => {
    const media = window.matchMedia("(max-width: 768px)");

    const listener = () => {
      // this isTouchDevice is use for check current device is mobile or not.
      const isTouchDevice =
        "ontouchstart" in window ||
        /(android|iphone|ipad|ipod|blackberry|bb10|mini|windows\sce|palm)/i.test(
          navigator.userAgent
        );
      setMatches(media.matches || isTouchDevice);
    };

    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }, []);

  return matches;
};

export default useIsMobile;
